import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, withKeys as _withKeys, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19225cb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrderHeader_MainArea" }
const _hoisted_2 = { class: "OrderHeader_SearchToggle" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "OrderHeader_SearchToggle_Button_Block" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "OrderHeader_Cart"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "OrderHeader_Cart_Text" }, "カート照会へ", -1))
const _hoisted_8 = {
  key: 0,
  class: "OrderHeader_ToggleArea"
}

import SearchSimple from "./search/SearchSimple.vue";
import SearchDetail from "./search/SearchDetail.vue";
import SearchConfirmDetail from "./search/SearchConfirmDetail.vue";
import SearchShippingHistoryDetail from "./search/SearchShippingHistoryDetail.vue";
import SearchReturnSlip from "./search/SearchReturnSlip.vue";
import SearchDeliverySlip from "./search/SearchDeliverySlip.vue";
import SearchDaiwari from "./search/SearchDaiwari.vue";
import vClickOutside from "click-outside-vue3";
import { ref, computed, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import store from "@/store";
import SearchList from "./search/SearchList.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderHeader',
  props: {
  isActive_SidebarFlg: {
    type: Boolean,
  },
  searchAreaToggle: {
    type: Boolean,
  },
  searchType: {
    type: String,
  },
},
  emits: [
  "changeKaniFlg",
  "changeSyosaiFlg",
  "changeToggleArea",
  "onSearch",
  "openCartNormal",
  "showList",
],
  setup(__props, { expose: __expose, emit: __emit }) {

const router = useRouter();
const route = useRoute();
//propsの定義
// eslint-disable-next-line no-unused-vars
const props = __props;
const path = route.path;

//Emitの定義
const emit = __emit;
const toggleAreaFlg = ref(true);
const simpleFlg = ref(false);
const detailFlg = ref(true);

// ストアの初期化
store.commit("search/setSimpleFlg", { simpleFlg: false });
const cartNum = computed(() => {
  return store.getters["search/getCartNormalNum"];
});
const checkInside = () => {
  //検索条件の表示非表示
  toggleAreaFlg.value = !toggleAreaFlg.value;
  if (toggleAreaFlg.value) {
    // emit("changeKaniFlg", false);
    // emit("changeSyosaiFlg", false);
    emit("changeToggleArea", toggleAreaFlg.value);
  } else {
    if (simpleFlg.value) {
      emit("changeKaniFlg", true);
      emit("changeSyosaiFlg", false);
      emit("changeToggleArea", toggleAreaFlg.value);
    } else if (detailFlg.value) {
      emit("changeKaniFlg", false);
      emit("changeSyosaiFlg", true);
      emit("changeToggleArea", toggleAreaFlg.value);
    }
  }
};
const toggleSimple = () => {
  //簡易検索の表示
  simpleFlg.value = true;
  store.commit("search/setSimpleFlg", { simpleFlg: true });
  if (!toggleAreaFlg.value && simpleFlg.value) {
    toggleAreaFlg.value = true;
  }
  detailFlg.value = false;
  if (simpleFlg.value) {
    emit("changeKaniFlg", true);
    emit("changeSyosaiFlg", false);
  }
};
const toggleDetail = () => {
  //詳細検索の表示
  detailFlg.value = true;
  if (!toggleAreaFlg.value && detailFlg.value) {
    toggleAreaFlg.value = true;
  }
  simpleFlg.value = false;
  store.commit("search/setSimpleFlg", { simpleFlg: false });
  if (detailFlg.value) {
    emit("changeKaniFlg", false);
    emit("changeSyosaiFlg", true);
  }
};
const toCartNormal = () => {
  router.push("/cartNormal");
};
const checkCart = () => {
  emit("openCartNormal");
};
const headerOutsideClick = () => {
  console.log("headerOutsideClick停止中");
  // this.toggleAreaFlg = false;
  // this.$emit("changeKaniFlg", false);
  // this.$emit("changeSyosaiFlg", false);
};
const onSearch = async () => {
  // サジェスト選択中でエンター押下時は検索処理を行わない
  const suggestElms = [
    ...document.getElementsByClassName("Search_Suggest_Content"),
  ];
  let hasHoverdsuggest = false;
  if (suggestElms.length > 0) {
    suggestElms.forEach((el) => {
      if (el.classList.contains("hoverd")) {
        hasHoverdsuggest = true;
        searchSimple.value.selectSuggestByEnter(el.children[0].innerHTML);
      }
    });
  }

  // サジェスト選択中でなければ検索実行
  if (!hasHoverdsuggest) {
    emit("onSearch");
    // サジェスト結果を取り直す
    setTimeout(() => {
      searchSimple.value.getSuggestData();
    }, 1000);
  }
};

// 条件リセットボタン押下時
const searchSimple = ref();
const searchConfirmDetail = ref();
const searchShippingHistoryDetail = ref();
const searchReturnSlip = ref();
const searchDeliverySlip = ref();
const searchDaiwari = ref();
const searchList = ref();
const searchDetail = ref();
const resetConditions = () => {
  searchSimple.value.resetConditions();
  if (toggleAreaFlg.value && props.searchAreaToggle) {
    if (detailFlg.value && props.searchType === "orderConfirm") {
      searchConfirmDetail.value.resetConditions();
    } else if (detailFlg.value && props.searchType === "shippingHistory") {
      searchShippingHistoryDetail.value.resetConditions();
    } else if (detailFlg.value && props.searchType === "returnSlip") {
      searchReturnSlip.value.resetConditions();
    } else if (detailFlg.value && props.searchType === "deliverySlip") {
      searchDeliverySlip.value.resetConditions();
    } else if (detailFlg.value && props.searchType === "daiwari") {
      searchDaiwari.value.resetConditions();
    } else if (detailFlg.value && props.searchType === "createList") {
      searchList.value.resetConditions();
    } else if (detailFlg.value) {
      searchDetail.value.resetConditions();
    }
  }
};

// 検索条件によって要素の幅を可変にする
const overAllWidth = () => {
  if (
    detailFlg.value &&
    (props.searchType === "orderConfirm" ||
      props.searchType === "shippingHistory" ||
      props.searchType === "daiwari")
  ) {
    return "OrderHeader_SearchWidthLong";
  } else if (detailFlg.value && props.searchType === "returnSlip") {
    return "OrderHeader_SearchWidthMiddle";
  } else {
    return "OrderHeader_SearchWidth";
  }
};

// F2キーで検索を実行する
onMounted(() => {
  document.addEventListener("keydown", onKeyDown);
});
const onKeyDown = (e: any) => {
  // console.log(e);
  if (e.key === "F2" && !e.altKey && !e.ctrlKey && !e.shiftKey) {
    e.preventDefault();
    onSearch();
  }
};

__expose({
  resetConditions,
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    onKeydown: _withKeys(onSearch, ["enter"]),
    class: _normalizeClass(["OrderHeader", [
      {
        SideBar_False: !__props.isActive_SidebarFlg,
      },
      { SideBar_True: __props.isActive_SidebarFlg },
      overAllWidth(),
    ]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (__props.searchAreaToggle)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (checkInside())),
              class: "OrderHeader_SearchToggle_Title"
            }, [
              (!toggleAreaFlg.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createVNode(_component_font_awesome_icon, { icon: "angle-down" }),
                    _createTextVNode(" 検索条件 ")
                  ]))
                : _createCommentVNode("", true),
              (toggleAreaFlg.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createVNode(_component_font_awesome_icon, { icon: "angle-up" }),
                    _createTextVNode(" 検索条件 ")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _hoisted_5,
        _createVNode(SearchSimple, {
          onOnSearch: onSearch,
          ref_key: "searchSimple",
          ref: searchSimple
        }, null, 512),
        _createElementVNode("button", {
          class: "OrderHeader_SearchToggle_Button_Reset",
          onClick: resetConditions
        }, " 条件リセット "),
        (_unref(path) === '/orderSearch')
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('showList'))),
              class: "OrderHeader_List_Btn"
            }, " 注文リスト一覧 "))
          : _createCommentVNode("", true)
      ]),
      (_unref(path) === '/orderSearch')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: checkCart,
              class: "OrderHeader_Cart_BtnGreen"
            }, " カート確認 "),
            _createElementVNode("button", {
              onClick: toCartNormal,
              class: "OrderHeader_Cart_Btn"
            }, [
              _withDirectives(_createElementVNode("span", { class: "OrderHeader_Cart_Badge" }, _toDisplayString(cartNum.value), 513), [
                [_vShow, cartNum.value > 0]
              ]),
              _createVNode(_component_font_awesome_icon, {
                class: "OrderHeader_Cart_Icon",
                icon: "cart-shopping"
              }),
              _hoisted_7
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (toggleAreaFlg.value && __props.searchAreaToggle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (detailFlg.value && __props.searchType === 'orderConfirm')
            ? (_openBlock(), _createBlock(SearchConfirmDetail, {
                key: 0,
                onOnSearch: onSearch,
                ref_key: "searchConfirmDetail",
                ref: searchConfirmDetail
              }, null, 512))
            : (detailFlg.value && __props.searchType === 'shippingHistory')
              ? (_openBlock(), _createBlock(SearchShippingHistoryDetail, {
                  key: 1,
                  onOnSearch: onSearch,
                  ref_key: "searchShippingHistoryDetail",
                  ref: searchShippingHistoryDetail
                }, null, 512))
              : (detailFlg.value && __props.searchType === 'returnSlip')
                ? (_openBlock(), _createBlock(SearchReturnSlip, {
                    key: 2,
                    onOnSearch: onSearch,
                    ref_key: "searchReturnSlip",
                    ref: searchReturnSlip
                  }, null, 512))
                : (detailFlg.value && __props.searchType === 'deliverySlip')
                  ? (_openBlock(), _createBlock(SearchDeliverySlip, {
                      key: 3,
                      onOnSearch: onSearch,
                      ref_key: "searchDeliverySlip",
                      ref: searchDeliverySlip
                    }, null, 512))
                  : (detailFlg.value && __props.searchType === 'daiwari')
                    ? (_openBlock(), _createBlock(SearchDaiwari, {
                        key: 4,
                        onOnSearch: onSearch,
                        ref_key: "searchDaiwari",
                        ref: searchDaiwari
                      }, null, 512))
                    : (detailFlg.value && __props.searchType === 'createList')
                      ? (_openBlock(), _createBlock(SearchList, {
                          key: 5,
                          onOnSearch: onSearch,
                          ref_key: "searchList",
                          ref: searchList
                        }, null, 512))
                      : (detailFlg.value)
                        ? (_openBlock(), _createBlock(SearchDetail, {
                            key: 6,
                            onOnSearch: onSearch,
                            ref_key: "searchDetail",
                            ref: searchDetail
                          }, null, 512))
                        : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 34)), [
    [_unref(vClickOutside), headerOutsideClick]
  ])
}
}

})